import { sendOfferLead } from './sendOfferLead'

/**
 * get redirect from NW
 * @param {NerdwalletLead} data
 * @param {string} backupLink
 * @param {string} source
 */
export const redirectToNerdwallet = async (data, backupLink, source) => {
  try {
    const resp = await sendOfferLead('/api/offer/nerdwallet-lead', data)
    const redirectUrl = resp && resp.redirectUrl ? resp.redirectUrl : null

    if (redirectUrl) {
      window.location.href = `${redirectUrl}&aff_sub=${source}`
      return
    }

    window.location.href = backupLink
  } catch (error) {
    console.error(error)
    window.location.href = backupLink
  }
}
